export default __webpack_public_path__ + "static/photo-9-d261ef788fadcaf206420f8e92411eb8.jpg";